
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Reuse Assets</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="(projectId || siteId) &amp;&amp; relocations.length &gt; 0 &amp;&amp; relocations[0]?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: relocations[0]?.projectId}">{{ relocations[0]?.projectName }}</a></li>
        <li class="breadcrumb-item" *ngIf="siteId &amp;&amp; relocations.length &gt; 0 &amp;&amp; relocations[0]?.siteName"><a [routerLink]="['/sites']" [queryParams]="{projectId: relocations[0]?.projectId}">Sites</a></li>
        <li class="breadcrumb-item" *ngIf="siteId &amp;&amp; relocations.length &gt; 0 &amp;&amp; relocations[0]?.siteName"><a [routerLink]="['/site']" [queryParams]="{id: siteId}">{{ relocations[0]?.siteName }}</a></li>
        <li class="breadcrumb-item active">Reuse Assets</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [searchHelp]="searchHelp" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" *ngIf="(projectId || siteId)" href="javascript:void(0)" (click)="create()">Reuse Assets</a></list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row" *ngFor="let relocation of relocations">
        <div class="col">
          <div class="card-item">
            <h4>{{ relocation.name }}</h4>
            <property-container>
              <property-item><a [routerLink]="['/device-relocation']" [queryParams]="{id: relocation.id}">Details</a></property-item>
              <property-item><a *ngIf="relocation.workflowId" [routerLink]="['/workflow', relocation.workflowId]">Enter Workflow</a></property-item>
            </property-container>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>